/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `0` - Taxable
* `1` - Non-taxable
* `2` - Untaxable
* `3` - Tax exemption
 */
export type CostTaxClassEnum = typeof CostTaxClassEnum[keyof typeof CostTaxClassEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CostTaxClassEnum = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
} as const;
